/**
 * @generated SignedSource<<2e42d36d85041d2c10eb48a237a94c15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedSelectProject_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "SharedSelectProject_user";
};
export type SharedSelectProject_user$key = {
  readonly " $data"?: SharedSelectProject_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedSelectProject_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedSelectProject_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6a31cbe2d8eba71b7fb305118d974484";

export default node;
